import {
  PDF_DOWNLOADS_REQUEST,
  PDF_DOWNLOADS_RECEIVED,
} from 'redux/actions/pdf-downloads';

const initialState = {
  hasError: false,
  loading: false,
  pdfDownloads: '',
};

export default function pdfDownloads(state = initialState, action) {
  switch (action.type) {
    case PDF_DOWNLOADS_REQUEST:
      return Object.assign({}, state, {
        hasError: false,
        loading: true,
        pdfDownloads: state.pdfDownloads,
      });
    case PDF_DOWNLOADS_RECEIVED:
      return Object.assign({}, state, {
        hasError: false,
        loading: false,
        pdfDownloads: action,
      });
    default:
      return state;
  }
}
